module.exports = __webpack_public_path__ + "img/logo-hp.8b0e7b1e.png";